import {
  Component,
  Input,
  ElementRef,
  ViewChild,
  OnInit,
  Output,
  EventEmitter,
  ViewEncapsulation,
} from '@angular/core';
import { InlineFieldInterfaceComponent } from '../inline-field-interface.component';
import { PartialFormField } from '../../form-fields/form-field.types';

@Component({
  templateUrl: './checkbox-inline-field.component.html',
  styleUrls: ['./checkbox-inline-field.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CheckboxInlineFieldComponent implements InlineFieldInterfaceComponent, OnInit {
  @ViewChild('inputEditorControl') inputEditorControl: ElementRef;

  @Input() model: any;
  @Input() fieldDef: any;
  @Input() data: any;
  @Input() excludeLabels: boolean = false;
  @Input() readonly: boolean = false;
  @Input() canClick: boolean = false;
  @Output() onClick: EventEmitter<PartialFormField> = new EventEmitter();
  @Output() update: EventEmitter<PartialFormField> = new EventEmitter();

  public value;
  public editing: boolean = false;

  public showTip: string;
  public options: any[] = [
    { id: 'true', value: 'Yes' },
    { id: 'false', value: 'No' },
    { id: 'notset', value: 'Not Set' },
  ];
  private _originalValue;

  constructor() {}

  ngOnInit() {
    this.value = this.fieldDef.meta?.value_hidden ? 'REDACTED' : this.model[this.fieldDef.name];
    this.showTip = this.fieldDef.meta?.calc_code;

    if (this.value === null || this.value === undefined) this.value = 'notset';
    else {
      let booleanValue = new Boolean(this.value);

      if (booleanValue === true || booleanValue === false) {
        this.value = JSON.parse(this.value.toString());
        this._originalValue = this.value;
      }
    }

    if (this.fieldDef.meta && this.fieldDef.meta.readonly) {
      this.readonly = this.fieldDef.meta.readonly;
    }
  }

  edit() {
    if (!this.editing && !this.readonly) {
      this.editing = true;
    }
  }

  onSelectionChange($event: Event) {
    this.onSave();
    this.editing = false;
  }

  onBlur($event: Event) {
    this.onSave();
    this.editing = false;
  }

  onSave() {
    if (this.value !== 'notset') {
      if (this._originalValue != this.value) {
        this.updateModel();
        this.update.emit({ [this.fieldDef.name]: this.value });
      }
    }
  }

  updateModel() {
    this.model[this.fieldDef.name] = this.value;
    this._originalValue = this.value;
  }

  displayValue(value) {
    if (String(value) === 'true') {
      return 'Yes';
    } else if (String(value) === 'false') {
      return 'No';
    } else {
      return 'Not Set';
    }
  }

  clickField($event) {
    this.onClick.emit($event);
  }
}
